import { formatDistanceToNow, differenceInMinutes, differenceInHours, differenceInDays, format } from 'date-fns';

export function convertTimestampToReadableFormat(timestamp: number) {
    let time = new Date(timestamp);
    let now = new Date();

    if (differenceInMinutes(now, time) < 1) {
        return 'Just now';
    } 
    else if (differenceInMinutes(now, time) < 60) {
        return formatDistanceToNow(time, { addSuffix: true }); 
    } 
    else if (differenceInHours(now, time) < 24) {
        return formatDistanceToNow(time, { addSuffix: true });
    } 
    else {
        let yesterday = new Date();
        yesterday.setDate(now.getDate() - 1);
        
        if(yesterday.toDateString() === time.toDateString()) {
            // If the timestamp is from yesterday
            return 'Yesterday at ' + format(time, 'hh:mm a');
        } 
        else {
            // If the timestamp is more than one day old
            return format(time, 'dd/MM/yyyy') + ' at ' + format(time, 'hh:mm a');
        }
    }
}

export function datePipeForTable(dateString: string) {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-US', options).format(new Date(dateString));

}
